export default {
  textField: {
    marginRight: 10,
    width: '90%'
  },
  ReactQuill: {
    maxWidth: '1000px'
  },
  MultiAddList: {
    maxWidth: '1100px',
    marginBottom: 20,
    marginTop: 0
  },
  bufferContainer: {
    marginBottom: 20,
    marginTop: 0
  },
  formContainerPadding: {
    paddingRight: 30,
    paddingLeft: 30,
    paddingBottom: 35
  },
  formCollapseButton: {
    position: 'relative',
    float: 'right'
  },
  formSectionHeader: {
    position: 'relative',
    paddingLeft: 25,
    paddingTop: 11
  },
  formCollapseButtonContainerLeft: {
    float: 'left'
  },
  formCollapseButtonContainerRight: {
    float: 'right'
  },
  sectionBuffer: {
    marginBottom: 20,
    marginTop: 20,
    border: '1px solid #CAC9C9'
  },
  dropdownBox: {
    flex: 1,
    flexDirection: 'row'
  },
  saveCaseContainer: {
    alignContent: 'flex-end'
  }
};



// WEBPACK FOOTER //
// ./src/views/CreateUser/CreateUser.css.js